/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'

const IconDone = props => {
  const { className, width = 24, height = 24, onClick, style } = props
  const title = 'icon-done'
  const dataTestId = props['data-testid'] || title

  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      onClick={onClick}
      data-testid={dataTestId}
    >
      <g data-rebalance="1.248" transform="translate(12 12) scale(1.248) translate(-12 -12)">
        <title>{title}</title>
        <path d="M9 16.176l-4.176-4.176-1.416 1.416 5.592 5.592 12-12-1.416-1.416z" />
      </g>
    </svg>
  )
}

export default IconDone
